import { AMAZON_STORE, NAV } from "../../data/content";
import { scrollToId } from "../../lib/scroll";

const scrollTo = (href) => scrollToId(href);

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--line)] bg-[#f4f2ec]"
    >
      <div className="mx-auto max-w-[1400px] px-6 pb-10 pt-24 md:px-10 md:pt-32">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <p className="max-w-md font-display text-3xl font-light leading-tight text-[#1c2b4a] md:text-4xl">
              Rebuilding in healthcare, law and design: its tools, its data and its language.
            </p>
            <button
              data-testid="footer-book-cta"
              onClick={() => scrollTo("#booking")}
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#9c7a33] px-7 py-3 text-sm text-[#f4f2ec] transition-colors hover:bg-[#7e6128]"
            >
              Book Adonica
            </button>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.24em] text-[#5c6474]">
              Explore
            </h4>
            <div className="mt-5 flex flex-col gap-3">
              {[...NAV.work, ...NAV.links].map((l) => (
                <button
                  key={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  onClick={() => scrollTo(l.href)}
                  className="w-fit text-sm text-[#1c2b4a]/80 transition-colors hover:text-[#9c7a33]"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.24em] text-[#5c6474]">
              Elsewhere
            </h4>
            <div className="mt-5 flex flex-col gap-3">
              <a
                href={AMAZON_STORE}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-amazon"
                className="w-fit text-sm text-[#1c2b4a]/80 transition-colors hover:text-[#9c7a33]"
              >
                Amazon Author Store
              </a>
              <a
                href="mailto:ashawporter@gmail.com"
                data-testid="footer-email"
                className="w-fit text-sm text-[#1c2b4a]/80 transition-colors hover:text-[#9c7a33]"
              >
                Email
              </a>
            </div>
          </div>
        </div>

        <div className="mt-24 overflow-hidden">
          <h2 className="whitespace-nowrap font-display text-[19vw] font-light leading-none tracking-tighter text-[#1c2b4a]/[0.07]">
            ADONICA SHAW
          </h2>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-[var(--line)] pt-8 text-xs text-[#5c6474] md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} Adonica Shaw. All rights reserved.</span>
          <span>Author · Founder · Advocate · Software & Medical Device Innovator</span>
        </div>
      </div>
    </footer>
  );
}
